import React from "react";
import { AGENT_STEPS, agentStepsDone } from "./helpers";

/**
 * Shows how far the agent has progressed through a run.
 *
 * @param {{run: object|null}} props - The run being tracked.
 * @returns {JSX.Element} The checklist.
 *
 * @remarks
 * Derived from the run's section statuses rather than a timer, so a stalled
 * pipeline stops advancing instead of showing invented progress.
 */
const AgentStatusPanel = ({ run }) => {
  const done = agentStepsDone(run);

  return (
    <section className="aica-card">
      <div className="aica-card-head">
        <h2>AI agent status</h2>
      </div>
      <div className="aica-steps">
        {AGENT_STEPS.map((label, index) => {
          const isDone = index < done;
          const isActive = index === done && run?.status === "ANALYZING";
          return (
            <div
              key={label}
              className={`aica-step ${isDone ? "is-done" : ""} ${
                isActive ? "is-active" : ""
              }`}
            >
              <span className="aica-step-icon">{isDone ? "✓" : ""}</span>
              {label}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default AgentStatusPanel;
